<div class="loader">
  <lottie-player
    src="../../../../assets/images/loader/lottie.json"
    background="transparent"
    speed="1"
    style="width: 325px; height: 252px"
    loop
    autoplay
  ></lottie-player>
</div>
